import {ActionTypes} from '../../actions';
import createReducer from '../../../common/util/createReducer';

const INITIAL_STATE_FILTER = {
  'list': [],
  'loading': false,
};

const INITIAL_STATE_COURSES = {
  'courses': [],
  'form': {},
  'loading': false,
};

export const wtsCoursesFilter = (state, action) => {
  return createReducer(INITIAL_STATE_FILTER, {
    [ActionTypes.FETCHING_WTS_COURSES_FILTER]: (state) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_WTS_COURSES_FILTER]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data || action.response || [],
    }),
    [ActionTypes.FETCHED_WTS_COURSES_FILTER_FAILED]: (state) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
  })(state, action);
};

export const wtsCourses = (state, action) => {
  return createReducer(INITIAL_STATE_COURSES, {
    [ActionTypes.FETCHING_WTS_COURSES]: (state) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_WTS_COURSES]: (state, action) => ({
      ...state,
      'loading': false,
      'courses': action.response.data || action.response || [],
    }),
    [ActionTypes.FETCHED_WTS_COURSES_FAILED]: (state) => ({
      ...state,
      'loading': false,
      'courses': [],
    }),
    [ActionTypes.FETCHING_WTS_COURSE]: (state) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_WTS_COURSE]: (state, action) => ({
      ...state,
      'loading': false,
      'form': action.response.data || action.response || {},
    }),
    [ActionTypes.CHANGE_WTS_COURSE_FORM]: (state, action) => ({
      ...state,
      'form': {
        ...state.form,
        [action.field]: action.value,
      },
    }),
    [ActionTypes.CLEAN_WTS_COURSE_FORM]: (state) => ({
      ...state,
      'form': INITIAL_STATE_COURSES.form,
    }),
    [ActionTypes.UPDATE_WTS_COURSE]: (state) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.UPDATED_WTS_COURSE]: (state) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.CREATE_WTS_COURSE]: (state) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.CREATED_WTS_COURSE]: (state) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.CREATED_WTS_COURSE_FAILED]: (state) => ({
      ...state,
      'loading': false,
    }),
  })(state, action);
};
